import axios from 'axios'

const BASE = import.meta.env.VITE_API_URL

export interface DemoAgent {
  id: string
  name: string
  emoji: string
  color: string
  role: string
  description: string
}

export interface DemoConfig {
  demo_enabled: boolean
  messages_allowed: number
  agents: DemoAgent[]
}

export interface DemoChatResponse {
  response: string
  agent_id: string
  agent_name: string
  agent_emoji: string
  agent_color: string
  messages_used: number
  messages_remaining: number
  limit: number
}

export async function getDemoConfig(): Promise<DemoConfig> {
  const { data } = await axios.get(`${BASE}/api/demo/config/`)
  return data as DemoConfig
}

export async function sendDemoMessage(
  message: string,
  agent_id: string | null,
  session_key: string
): Promise<DemoChatResponse> {
  const { data } = await axios.post(`${BASE}/api/demo/chat/`, {
    message,
    agent_id,
    session_key,
  })
  return data as DemoChatResponse
}
